(() => {
  const normalizeThirdPartyMarkup = (root = document) => {
    root.querySelectorAll?.('h3.jdgm-revs-tab__title').forEach((heading) => {
      if (heading.textContent.trim() !== 'Let customers speak for us') return;

      const paragraph = document.createElement('p');

      for (const attribute of heading.attributes) {
        paragraph.setAttribute(attribute.name, attribute.value);
      }

      while (heading.firstChild) {
        paragraph.appendChild(heading.firstChild);
      }

      heading.replaceWith(paragraph);
    });

    root.querySelectorAll?.('a[href]').forEach((link) => {
      const url = new URL(link.getAttribute('href'), window.location.origin);

      if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/pages/reviews') {
        link.setAttribute('href', '/pages/avis');
      }
    });
  };

  normalizeThirdPartyMarkup();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) normalizeThirdPartyMarkup(node);
      }
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 15000);
  document.addEventListener('shopify:section:load', (event) => normalizeThirdPartyMarkup(event.target));
})();
